export default __webpack_public_path__ + "static/media/logo.3788a26c.png";